
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/institutions",
      function () {
        return require("private-next-pages/docs/api/institutions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/institutions"])
      });
    }
  